import React from "react";
import { DataTableMultiSelectFilter } from "../../../library/DataTable";
import { sortByLabel } from "../../../../utils/LinkedProgrammeUtils";

const GRADES_OPTIONS = [
    { value: "1", label: "Locked" },
    { value: "0", label: "Unlocked" },
];

/**
 * The linked-programmes DataTable filters (Intake, Campus, Method, Grades, Version); every
 * change also resets pagination back to page 1.
 * @param {Object} hook State and handlers from the linked-programmes list hook.
 */
function LinkedProgrammeFilters({ hook }) {
    const filters = [
        { key: "intake", placeholder: "Intake", value: hook.intake, setValue: hook.setIntake, options: sortByLabel(hook.dropdown.intake, true) },
        { key: "campus", placeholder: "Campus", value: hook.campus, setValue: hook.setCampus, options: sortByLabel(hook.dropdown.campus) },
        { key: "method", placeholder: "Method", value: hook.delivery, setValue: hook.setDelivery, options: sortByLabel(hook.dropdown.deliveryMethod) },
        { key: "grades", placeholder: "Grades", value: hook.gradesLocked, setValue: hook.setGradesLocked, options: GRADES_OPTIONS },
    ];

    if (hook.isVersionEnabled) {
        filters.push({ key: "version", placeholder: "Version", value: hook.version, setValue: hook.setVersion, options: sortByLabel(hook.versionFilterOptions) });
    }

    return filters.map((filter) => (
        <DataTableMultiSelectFilter
            key={filter.key}
            placeholder={filter.placeholder}
            value={filter.value}
            onChange={(event) => {
                filter.setValue(event.target.value);
                hook.setPage(1);
            }}
            options={filter.options}
            disabled={hook.isProcessing}
            disabledReason="A bulk action is currently running"
        />
    ));
}

export default LinkedProgrammeFilters;
